import classNames from 'classnames';
import React from 'react';
import TextWithIcon from '../../../components/TextWithIcon';
import { gql } from '../../../graphql/generated/gql';
import type { DocumentType } from '../../../graphql/generated/gql';
import VerifiedIcon from '../../../post/VerifiedIcon';
import getVerificationStatus, {
  VerificationStatus,
} from '../../../post/getVerificationStatus';
import * as styles from './PostTitleWithVerified.module.scss';

const POST_FRAGMENT = gql(`
  fragment PostTitleWithVerified_post on Post {
    id
    title
    ...getVerificationStatus_post
  }
`);

interface PostTitleWithVerifiedProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  iconSize?: 'small' | 'regular';
  truncate?: boolean;
}

const PostTitleWithVerified = ({
  post,
  iconSize = 'regular',
  truncate,
}: PostTitleWithVerifiedProps) => (
  <TextWithIcon
    text={post.title}
    icon={
      getVerificationStatus(post) === VerificationStatus.Verified && (
        <span className={classNames(styles.icon, styles[iconSize])}>
          <VerifiedIcon inline size={iconSize} />
        </span>
      )
    }
    truncate={truncate || undefined}
  />
);

export default PostTitleWithVerified;
